
import { createLogic, createLogicMiddleware } from 'redux-logic'
import { routeToDisconnect } from '../actions/routing'
import { setDisconnectMessage, raiseError, gracefulExit } from './../actions/disconnect'
import { closePeerConnection } from '../actions/webrtcConnection'
import { APP_STEP, step } from '../actions/app'
import { NOT_FOUND } from 'redux-first-router'
import { tryClosingWss } from '../actions/wss'
import { audioChatEnd, stopListenMediaDevicesChange } from '../actions/media'

export const errorLogic = createLogic({
  type: [raiseError, NOT_FOUND],
  latest: true,

  process ({ action }, dispatch, done) {
    dispatch(gracefulExit())
    if (action.type === NOT_FOUND) {
      dispatch(setDisconnectMessage('page-not-found'))
    } else {
      dispatch(setDisconnectMessage(action.payload))
    }
    done()
  }
})

export const disconnectLogic = createLogic({
  type: [setDisconnectMessage],
  latest: true,

  process (args, dispatch, done) {
    dispatch(routeToDisconnect())
    done()
  }
})

export const gracefulExitLogic = createLogic({
  type: [gracefulExit],

  process ({ getState }, dispatch, done) {
    // ensure we are on the disconnect path (route ROUTE_TO_DISCONNECT, current=ROUTE_TO_DISCONNECT)
    // so AppContainer to render the DISCONNECT message
    dispatch(routeToDisconnect())
    dispatch(step(APP_STEP.CLOSING))
    const { audio: { chatStarted }, mediaDevices: { listening } } = getState()
    if (chatStarted) {
      dispatch(audioChatEnd({ endByPeer: false }))
    } else if (listening) {
      dispatch(stopListenMediaDevicesChange())
    }
    // close rtc connection
    dispatch(closePeerConnection())
    // close wss
    dispatch(tryClosingWss())
    dispatch(step(APP_STEP.CLOSED))
    done()
  }
})

const arrLogic = [errorLogic, disconnectLogic, gracefulExitLogic]

export const disconnectLogicMiddleware = createLogicMiddleware(arrLogic)
